import { Container, Col, Row} from "react-bootstrap";
import "../styles/feature.css"

export const About = () => {
    return (
        <Container fluid>
            <Row>
                <Col>
                    <h3 style={{ color: 'rgb(0, 0, 0)' }}>About Me</h3>
                    <p style={{ color: 'rgb(0, 0, 0)' }}>Hi, I'm Douglas Zuniga, a passionate software developer with a knack for creating dynamic and responsive web applications.</p>
                </Col>
            </Row>
        </Container>
    );
}